import { cur } from './units';
import { scafState } from './inspect';

// scaffold rental reminders: .ics calendar file (alarm 7 days before) + service-worker notification
const NOTIFY_KEY = 'giss_sc_notify';
const pad = (n) => String(n).padStart(2, '0');
const local8 = (ms) => { const d = new Date(ms); return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T080000`; };
const esc = (s) => String(s || '').replace(/[\\;,]/g, (c) => `\\${c}`).replace(/\n/g, '\\n');

export const icsItems = (list) => list.map((s) => ({ s, r: scafState(s) })).filter(({ s, r }) => r.due && !s.end);

export function scafIcs(t, list, projName) {
  const ev = icsItems(list);
  if (!ev.length) return null;
  const now = new Date().toISOString().replace(/[-:]/g, '').slice(0, 15) + 'Z';
  const alarm = (trg) => ['BEGIN:VALARM', 'ACTION:DISPLAY', `DESCRIPTION:${esc(t.scIcsAlarm)}`, `TRIGGER:${trg}`, 'END:VALARM'];
  return ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//GISS//FieldRapport Pro//DE', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
    ...ev.flatMap(({ s, r }) => ['BEGIN:VEVENT', `UID:${s.id}-${r.due}@giss-fieldrapport`, `DTSTAMP:${now}`, `DTSTART:${local8(r.due)}`, 'DURATION:PT1H',
      `SUMMARY:${esc(`${t.scIcsTitle}: ${s.name || ''}${projName ? ` (${projName})` : ''}`)}`,
      `DESCRIPTION:${esc(`${t.scStart}: ${s.start} · ${s.weeks} ${t.scWeeksShort}${s.price ? ` · ${s.price} ${cur()}/${t.scWeeksShort}` : ''}`)}`,
      ...alarm('-P7D'), ...alarm('-P1D'), 'END:VEVENT']),
    'END:VCALENDAR'].join('\r\n');
}

export function downloadIcs(t, list, projName) {
  const ics = scafIcs(t, list, projName);
  if (!ics) return false;
  const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
  const a = Object.assign(document.createElement('a'), { href: url, download: `Geruest-Mietende-${(list.length === 1 ? list[0].name : projName || 'GISS').replace(/[^\w-]+/g, '_')}.ics` });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
  return true;
}

export const notifyOn = () => localStorage.getItem(NOTIFY_KEY) === '1' && typeof Notification !== 'undefined' && Notification.permission === 'granted';

async function pushTexts(t) {
  const c = await caches.open('giss-cfg');
  await c.put('/__giss/sc-msg', new Response(JSON.stringify({ title: `🪜 ${t.scIcsTitle}`, body: t.scNotifyBody, over: t.scNotifyOver, locale: t.locale })));
}

// tells the service worker to check all scaffolds now (also used on app start)
export async function scafCheck(t) {
  if (!notifyOn() || !navigator.serviceWorker) return;
  await pushTexts(t);
  const reg = await navigator.serviceWorker.ready;
  reg.active?.postMessage('giss-scaffold-check');
}

export async function enableScafNotify(t) {
  if (typeof Notification === 'undefined' || !navigator.serviceWorker) return 'no';
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') return 'denied';
  const reg = await navigator.serviceWorker.ready;
  localStorage.setItem(NOTIFY_KEY, '1');
  let bg = false;
  try {
    const st = await navigator.permissions.query({ name: 'periodic-background-sync' });
    if (st.state === 'granted' && reg.periodicSync) { await reg.periodicSync.register('giss-scaffold', { minInterval: 12 * 3600e3 }); bg = true; }
  } catch { /* not supported */ }
  await scafCheck(t);
  return bg ? 'ok' : 'start';
}
